import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import myImage from '../../Images/myimg.jpg';
import { blogs } from '../../Data/Blog';

function Blog() {
    // Function to truncate blog content
    const truncateContent = (content, limit) => {
        const words = content.split(' ');
        if (words.length > limit) {
            return words.slice(0, limit).join(' ') + '...';
        }
        return content;
    };

    // Function to render individual blog post
    const renderBlog = (blog) => (
        <div key={blog.id} className="p-4">
            <div className="bg-gray-100 dark:bg-gray-800 rounded-lg shadow-lg">
                <img
                    className="object-cover w-full h-36 rounded-t-lg lg:h-48"
                    src={blog.imageUrl}
                    alt={blog.title}
                />
                <div className="p-6">
                    <a
                        href={blog.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block mt-4 text-2xl font-semibold text-gray-800 hover:underline dark:text-gray-200"
                    >
                        {blog.title}
                    </a>
                    <div
                        className="mt-3 text-sm text-gray-600 dark:text-gray-300"
                        dangerouslySetInnerHTML={{ __html: truncateContent(blog.content, 70) }}
                    />
                    <a
                        href={blog.href}
                        className="inline-block mt-2 text-blue-500 hover:text-blue-400"
                    >
                        Read more
                    </a>
                    <div className="flex items-center mt-6">
                        <img
                            className="object-cover object-center w-10 h-10 rounded-full"
                            src={myImage}
                            alt={blog.author}
                        />
                        <div className="mx-4">
                            <h1 className="text-sm text-gray-700 dark:text-gray-200">{blog.author}</h1>
                            <p className="text-sm text-gray-500 dark:text-gray-400">{blog.contributor}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    // Settings for react-multi-carousel
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1024 },
            items: 3,
        },
        desktop: {
            breakpoint: { max: 1024, min: 768 },
            items: 2,
        },
        tablet: {
            breakpoint: { max: 768, min: 464 },
            items: 1,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
        },
    };

    return (
        <section className="" id="blog">
            <div className="container px-6 py-10 mx-auto">
                <h1 className="text-2xl font-semibold text-center capitalize lg:text-3xl text-gray-800 dark:text-white">
                    FROM THE BLOG
                </h1>
                <Carousel responsive={responsive}>
                    {blogs.map((blog) => renderBlog(blog))}
                </Carousel>
            </div>
        </section>
    );
}

export default Blog;